export default function ToggleButton({onToggle}:{onToggle:()=> void}){
  return (
    <div className='toggler' onClick={onToggle} />
  )
}